(function ($) {$.fn.efw$local.data={
  "general.success.title": {
    "EN": "Success",
    "ES": "Éxito"
  },
  "general.fail.title": {
    "EN": "A Problem Occurred",
    "ES": "Se produjo un problema"
  },
  "general.ajax.error.notconnected": {
    "EN": "Not connected. Verify Network.",
    "ES": "No está conectado. Verifique la red."
  },
  "general.ajax.error.notfound": {
    "EN": "Requested service not found. [404]",
    "ES": "Servicio solicitado no encontrado. [404]"
  },
  "general.ajax.error.internal": {
    "EN": "Internal server error. [500]",
    "ES": "Error interno del servidor. [500]"
  },
  "general.ajax.error.parsererror": {
    "EN": "Requested parse failed.",
    "ES": "El análisis solicitado falló. "
  },
  "general.ajax.error.timeout": {
    "EN": "Timeout.",
    "ES": "Se acabó el tiempo."
  },
  "general.ajax.error.abort": {
    "EN": "Request aborted.",
    "ES": "Solicitud cancelada."
  },
  "general.ajax.error.unknown": {
    "EN": "Unknown error.",
    "ES": "Error desconocido."
  },
  "general.ajax.error.notauthorized": {
    "EN": "Not authorized. Please <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">sign in</a>.",
    "ES": "No está autorizado. Por favor, <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">inicie sesión</a>."
  },
  "general.label.popuptool": {
    "EN": "Popup tool",
    "ES": "Herramienta"
  },
  "logon.area.logon.prompt": {
    "EN": "Sign In",
    "ES": "Iniciar sesión"
  },
  "logon.area.register.prompt": {
    "EN": "Register",
    "ES": "Registrar"
  },
  "logon.area.help.prompt": {
    "EN": "What's This?",
    "ES": "¿Qué es esto?"
  },
  "logon.area.logout.prompt": {
    "EN": "Log out",
    "ES": "Cerrar la sesión"
  },
  "logon.success.title": {
    "EN": "Welcome",
    "ES": "Bienvenido/a"
  },
  "logon.success.message": {
    "EN": "You are now logged in.",
    "ES": "Sesión iniciada."
  },
  "logon.fail.title": {
    "EN": "Login Unsuccessful",
    "ES": "No se pudo iniciar sesión"
  },
  "logon.fail.message": {
    "EN": "Unrecognized username or password",
    "ES": "No se reconoció el nombre de usuario o contraseña."
  },
  "logon.disabled.message": {
    "EN": "Your account has been disabled",
    "ES": "Su cuenta está desactivada"
  },
  "logon.changepassword.success.title": {
    "EN": "Password Successfully Changed",
    "ES": "Se cambió la contraseña correctamente."
  },
  "logon.changepassword.success.message": {
    "EN": "Please <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">sign in again</a>.",
    "ES": "Por favor, <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">inicie sesión de nuevo</a>."
  },
  "logon.enable.success.title": {
    "EN": "Success",
    "ES": "Éxito"
  },
  "logon.enable.success.message": {
    "EN": "Account successfully enabled.",
    "ES": "Cuenta activada"
  },
  "logon.disable.success.title": {
    "EN": "Success",
    "ES": "Éxito"
  },
  "logon.disable.success.message": {
    "EN": "Account successfully disabled.",
    "ES": "Cuenta desactivada"
  },
  "logon.mail.confirm.success.message": {
    "EN": "Thank you for registering an account!",
    "ES": "¡Gracias por registrar una cuenta!"
  },
  "logon.mail.confirm.failure.message": {
    "EN": "Thank you for registering an account!",
    "ES": "¡Gracias por registrar una cuenta!"
  },
  "logon.register.error.taken": {
    "EN": "That email is already taken. Please <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">sign in</a> instead.",
    "ES": "Esa dirección de correo electrónico ya está en uso. Por favor, <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">inicie sesión</a>."
  },
  "logon.register.error.emailrequired": {
    "EN": "Please provide a valid email address.",
    "ES": "Por favor, introduzca una dirección de correo electrónico válida."
  },
  "logon.password.error.noconfirm": {
    "EN": "Please enter the same password again.",
    "ES": "Por favor, introduzca la misma contraseña de nuevo."
  },
  "logon.password.error.tooshort": {
    "EN": "Password must contain at least {0} characters.",
    "ES": "La contraseña debe contener al menos {0} caracteres."
  },
  "logon.password.error.nospecial": {
    "EN": "Password must contain at least one special character (not a letter or digit).",
    "ES": "La contraseña debe contener al menos un carácter especial (no una letra o un dígito)."
  },
  "logon.forgot.success.title": {
    "EN": "Check Your Email",
    "ES": "Revise su correo electrónico"
  },
  "logon.forgot.success.message": {
    "EN": "Follow the instructions to reset your password.",
    "ES": "Siga las instrucciones para restablecer su contraseña."
  },
  "logon.forgot.fail.title": {
    "EN": "Password Could Not Be Reset",
    "ES": "No se pudo restablecer la contraseña."
  },
  "logon.forgot.fail.message": {
    "EN": "Please check your email address and try again.",
    "ES": "Compruebe su dirección de correo electrónico y vuelva a intentarlo."
  },
  "logon.reset.success.title": {
    "EN": "Password Successfully Reset",
    "ES": "Se restableció la contraseña exitosamente"
  },
  "logon.reset.success.message": {
    "EN": "Please <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">sign in again</a>.",
    "ES": "Por favor, <a href=\"#logon\" class=\"dlgPop\" target=\"_self\">inicie sesión de nuevo</a>."
  },
  "logon.reset.fail.title": {
    "EN": "Password Could Not Be Reset",
    "ES": "No se pudo restablecer la contraseña."
  },
  "logon.reset.fail.message": {
    "EN": "Your reset code did not work. <a href=\"#forgot\" class=\"dlgPop\" target=\"_self\">Please try the \"Forgot Password\" process again</a>.",
    "ES": "Su código de restablecimiento no funcionó.<a href=\"#forgot\" class=\"dlgPop\" target=\"_self\">Intente el proceso de \"Olvidé mi contraseña\" de nuevo</a>."
  },
  "logon.register.success.title": {
    "EN": "Successfully Created Account",
    "ES": "Se creó la cuenta exitosamente."
  },
  "logon.register.success.message": {
    "EN": "<p>You are now logged in. Please check your email for instructions to verify your email address.</p>",
    "ES": "<p>Se ha enviado un mensaje a esta direcci&oacute;n para confirmar su correo electr&oacute;nico.</p>"
  },
  "logon.provision.success.title": {
    "EN": "Successfully Created Account",
    "ES": "Se creó la cuenta exitosamente."
  },
  "logon.provision.success.message": {
    "EN": "New user will receive an email with password reset instructions.",
    "ES": ""
  },
  "logon.sendconfirm.success.title": {
    "EN": "Email Sent",
    "ES": "Correo electrónico enviado"
  },
  "logon.sendconfirm.success.message": {
    "EN": "<p>A confirmation email has been sent to this address.</p>",
    "ES": "<p>Se ha enviado un mensaje a esta direcci&oacute;n para confirmar su correo electr&oacute;nico.</p>"
  },
  "logon.update.error.taken": {
    "EN": "You already have an account. Please sign in.",
    "ES": "Esa dirección de correo electrónico ya está en uso."
  },
  "logon.update.success.title": {
    "EN": "Profile successfully updated",
    "ES": "Perfil actualizado correctamente"
  },
  "logon.update.success.message": {
    "EN": "",
    "ES": ""
  },
  "logon.update.email.success.title": {
    "EN": "Profile successfully updated",
    "ES": "Perfil actualizado correctamente"
  },
  "logon.update.email.success.message": {
    "EN": "<p>A confirmation email has been sent to this address.</p>",
    "ES": "<p>Se ha enviado un mensaje a esta direcci&oacute;n para confirmar su correo electr&oacute;nico.</p>"
  },
  "logon.addtorole.user.fail.title": {
    "EN": "No such user",
    "ES": "Ese usuario no existe."
  },
  "logon.addtorole.user.fail.message": {
    "EN": "No user was found with that email address.",
    "ES": "No se encontró ningún usuario con esa dirección de correo electrónico."
  },
  "logon.addtorole.role.fail.title": {
    "EN": "<p>No such role</p>",
    "ES": "<p>No existe esa funci&oacute;n.</p>"
  },
  "logon.addtorole.role.fail.message": {
    "EN": "No role with that name was found.",
    "ES": "No se encontró ninguna función con ese nombre."
  },
  "logon.create.rolerequest.notfound": {
    "EN": "No role with that name was found.",
    "ES": "No se encontró ninguna función con ese nombre."
  },
  "logon.create.rolerequest.notrequestable": {
    "EN": "That role cannot be requested.",
    "ES": "No se puede solicitar este rol."
  },
  "logon.create.rolerequest.success": {
    "EN": "Role requested! Please watch your email to see if it's granted.",
    "ES": "Se ha enviado la solicitud del rol. La respuesta le llegará por correo electrónico."
  },
  "logon.create.rolerequest.supervisorrequired": {
    "EN": "You must provide your supervisor's name and email in order to request that role.",
    "ES": "Necesita dar el nombre y correo electrónico de su supervior para solicitar este rol."
  },
  "logon.resolve.rolerequest.notfound": {
    "EN": "No matching role request was found. It may have been resolved or deleted.",
    "ES": "No se ha encontrado esta solicitud de rol. Es posible que ya se haya resuelto o borrado."
  },
  "logon.resolve.rolerequest.notrequestable": {
    "EN": "That role cannot be requested.",
    "ES": "No se puede solicitar este rol."
  },
  "logon.resolve.rolerequest.unauthorized": {
    "EN": "You aren't authorized to approve that role request.",
    "ES": "Usted no tiene autorización para aprobar este solicitud de rol."
  },
  "logon.resolve.rolerequest.success": {
    "EN": "The requester will be notified by email.",
    "ES": "Se enviará un correo electrónico a la persona que solicitó el rol."
  },
  "logon.notify.rolerequest.success": {
    "EN": "All approvers will be notified.",
    "ES": "Se mandará una notificación a todas las personas que pueden aprobar solicitudes de roles."
  },
  "logon.request.success.title": {
    "EN": "Request sent",
    "ES": "Solicitud enviada"
  },
  "logon.create.managedrole.success": {
    "EN": "Created roles \"{{RoleName}}\" and \"{{ManagerRoleName}}.\"",
    "ES": ""
  },
  "validate.email": {
    "EN": "Please enter a valid email address.",
    "ES": "Por favor, introduzca una dirección de correo electrónico válida."
  },
  "validate.url": {
    "EN": "Please enter a valid URL.",
    "ES": "Por favor, introduzca un URL válido."
  },
  "validate.date": {
    "EN": "Please enter a valid date.",
    "ES": "Por favor, introduzca una fecha válida."
  },
  "validate.number": {
    "EN": "Please enter a valid number.",
    "ES": "Por favor, introduzca un número válido."
  },
  "validate.digits": {
    "EN": "Please enter only digits.",
    "ES": "Introduzca solo dígitos."
  },
  "validate.creditcard": {
    "EN": "Please enter a valid credit card number.",
    "ES": "Por favor, introduzca un número de tarjeta de crédito válido."
  },
  "validate.equalTo": {
    "EN": "Please enter the same value again.",
    "ES": "Por favor, introduzca el mismo valor de nuevo."
  },
  "validate.accept": {
    "EN": "Please enter a value with a valid extension.",
    "ES": "Por favor, introduzca un valor con una extensión válida."
  },
  "validate.maxlength": {
    "EN": "$.validator.format(\"Please enter no more than {0} characters.\")",
    "ES": "$.validator.format (\"Introduzca no más de {0} caracteres.\" )"
  },
  "validate.minlength": {
    "EN": "$.validator.format(\"Please enter at least {0} characters.\")",
    "ES": "$.validator.format (\"Introduzca al menos {0} caracteres.\")"
  },
  "validate.rangelength": {
    "EN": "$.validator.format(\"Please enter a value between {0} and {1} characters long.\")",
    "ES": "$.validator.format(\"Introduzca un valor entre {0} y {1} caracteres.\")"
  },
  "validate.range": {
    "EN": "$.validator.format(\"Please enter a value between {0} and {1}.\")",
    "ES": "$.validator.format(\"Introduzca un valor entre {0} y {1}.\")"
  },
  "validate.max": {
    "EN": "$.validator.format(\"Please enter a value less than or equal to {0}.\")",
    "ES": "$.validator.format(\"Introduzca un valor menor o igual a {0}.\")"
  },
  "validate.min": {
    "EN": "$.validator.format(\"Please enter a value greater than or equal to {0}.\")",
    "ES": "$.validator.format(\"Introduzca un valor mayor o igual a {0}.\")"
  },
  "validate.requireSpecialChar": {
    "EN": "Password must contain at least one special character (not a letter or digit).",
    "ES": "La contraseña debe contener al menos un carácter especial (no una letra o un dígito)."
  },
  "validate.matchPass": {
    "EN": "Please enter the same password again.",
    "ES": "Por favor, introduzca la misma contraseña de nuevo."
  },
  "validate.required": {
    "EN": "Please enter a value.",
    "ES": "Por favor, introduzca un valor."
  },
  "validate.captcha": {
    "EN": "Please confirm that you are not a robot.",
    "ES": "Por favor, confirme que no es robot."
  },
  "favorite.area.articles.title": {
    "EN": "Favorite Articles",
    "ES": "Artículos favoritos"
  },
  "favorite area.tools title": {
    "EN": "Favorite Tools",
    "ES": "Herramientas favoritas"
  },
  "favorite.area.none.message": {
    "EN": "You have no favorites yet. Add favorite articles and tools to your list while you browse the site.",
    "ES": "Aún no tiene favoritos. Puede agregarlos mientras navega por el sitio."
  },
  "favorite.area.tools.none.message": {
    "EN": "You have no favorite tools yet. Add favorite articles and tools to your list while you browse the site.",
    "ES": "Aún no tiene favoritos. Puede agregarlos mientras navega por el sitio."
  },
  "favorite.delete": {
    "EN": "Delete",
    "ES": "Borrar"
  },
  "favorite.ui.add.prompt": {
    "EN": "Add to Favorites",
    "ES": "Añadir a Mis Favoritos"
  },
  "favorite.ui.is.prompt": {
    "EN": "One of my favorites",
    "ES": "Uno de mis favoritos"
  },
  "logon.intent.savesession": {
    "EN": "Sign In or Register to Save Your Session",
    "ES": "Inicie sesión o regístrese para guardar su sesión."
  },
  "logon.intent.savefavorites": {
    "EN": "Sign In or Register to Save Favorites",
    "ES": "Inicie sesión o regístrese para guardar favoritos."
  },
  "logon.intent.getsession": {
    "EN": "Sign In or Register to Get Saved Sessions",
    "ES": "Inicie sesión o regístrese para acceder a sesiones guardadas."
  },
  "savedsession.created": {
    "EN": "Created",
    "ES": "Creado"
  },
  "savedsession.saved": {
    "EN": "Saved",
    "ES": "Guardado"
  },
  "savedsession.confirmdelete": {
    "EN": "Are you sure you want to delete the saved session?",
    "ES": "¿Está seguro de que desea eliminar la sesión guardada?"
  },
  "savedsession.confirmdeleteall": {
    "EN": "Are you sure you want to delete the saved sessions?",
    "ES": "¿Está seguro de que quiere eliminar las sesiones guardadas?"
  },
  "savedsession.sessionsavedprompt": {
    "EN": "Session Saved",
    "ES": "La sesión se ha guardado."
  },
  "savedsession.getoldsessions.prompt": {
    "EN": "Import Sessions You Saved Before",
    "ES": "Importar sesiones guardadas anteriormente"
  },
  "savedsession.recent.prompt": {
    "EN": "Recent Sessions",
    "ES": "Sesiones recientes"
  },
  "savedsession.more.prompt": {
    "EN": "More sessions",
    "ES": "Más sesiones"
  },
  "personal.edit.prompt": {
    "EN": "Edit",
    "ES": "Editar"
  },
  "personal.stopediting.prompt": {
    "EN": "Stop editing",
    "ES": "No editar más"
  },
  "savedsession.getolder.prompt": {
    "EN": "Get older saved sessions (before %date%)",
    "ES": "Obtener sesiones guardadas anteriores (antes de %date%)."
  },
  "growbox.showmore": {
    "EN": "Show more",
    "ES": "Mostrar más"
  },
  "growbox.showless": {
    "EN": "Show less",
    "ES": "Mostrar menos"
  },
  "toolcollapse.showmore": {
    "EN": "Try it",
    "ES": "Probar ahora"
  },
  "toolcollapse.showless": {
    "EN": "Close",
    "ES": "Cerrar"
  },
  "vault.notify.upload.title": {
    "EN": "Session saved",
    "ES": "Se ha guardado la sesión."
  },
  "vault.notify.upload.message": {
    "EN": "A PDF report of this session has been saved in your Vault Files.",
    "ES": "Se ha guardado una copia de sus resultados en formato PDF en el Vault."
  },
  "twitter.retweeted": {
    "EN": "Retweeted",
    "ES": "compartió"
  },
  "twitter.like": {
    "EN": "Like",
    "ES": "Me gusta"
  },
  "twitter.share": {
    "EN": "Share",
    "ES": "Compartir"
  },
  "twitter.shareon": {
    "EN": "Share on",
    "ES": "Compartir en"
  },
  "general.ui.yes": {
    "EN": "Yes",
    "ES": "Sí"
  },
  "general.ui.no": {
    "EN": "No",
    "ES": "No"
  },
  "general.ui.learnmore": {
    "EN": "Learn More",
    "ES": "Más información"
  },
  "general.ui.confirm": {
    "EN": "Confirm",
    "ES": "Confirmar"
  },
  "general.ui.ok": {
    "EN": "OK",
    "ES": "OK"
  },
  "general.ui.cancel": {
    "EN": "Cancel",
    "ES": "Cancelar"
  },
  "general.feedback.thanks": {
    "EN": "Thank you for your submission.",
    "ES": "Gracias por sus comentarios."
  },
  "general.ui.submit": {
    "EN": "Submit",
    "ES": ""
  },
  "unsubscribe.area.email": {
    "EN": "Email",
    "ES": ""
  },
  "unsubscribe.type.ap": {
    "EN": "Vault Action Plan reminders",
    "ES": ""
  },
  "unsubscribe.fail.message": {
    "EN": "Can't unsubscribe. Your email link may be corrupted.",
    "ES": ""
  },
  "unsubscribe.success.message": {
    "EN": "You have been unsubscribed.",
    "ES": ""
  },
  "_org_AIHP-AZ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>American Indian Health Plan Provider",
    "ES": ""
  },
  "_org_AJC": {
    "EN": "NCWorks Career Center staff",
    "ES": "Empleado/a de un Centro profesional NCWorks"
  },
  "_org_AJC-MO": {
    "EN": "Missouri Job Center",
    "ES": ""
  },
  "_org_B2W-AZ": {
    "EN": "<p>Ability360</p>",
    "ES": ""
  },
  "_org_BEN-MO": {
    "EN": "Certified Work Incentive Planner",
    "ES": ""
  },
  "_org_BEN-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Benefits Counselor",
    "ES": ""
  },
  "_org_BH": {
    "EN": "Behavioral Health Provider",
    "ES": "Proveedor de servicios psiquiátricos"
  },
  "_org_BH-DDD-AZ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Behavioral Health AND DDD Provider",
    "ES": ""
  },
  "_org_BHS-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Local Benefits and Human Services Office",
    "ES": ""
  },
  "_org_BSBP-MI": {
    "EN": "Bureau of Services for Blind Persons",
    "ES": ""
  },
  "_org_CAREGIVER-NJ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Non-family caregiver",
    "ES": ""
  },
  "_org_Case-MO": {
    "EN": "Mental Health/Substance Abuse case manager",
    "ES": ""
  },
  "_org_CASE-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Case Management Agency",
    "ES": ""
  },
  "_org_CCB-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Community Centered Board",
    "ES": ""
  },
  "_org_CES-OH": {
    "EN": "Community/Employment Services Provider",
    "ES": ""
  },
  "_org_CIL": {
    "EN": "<p>Center for Independent Living staff</p>",
    "ES": "<p>Trabajador/a en un Centro de Vida Independiente</p>"
  },
  "_org_CIL-MI": {
    "EN": "Disability Network/CIL",
    "ES": ""
  },
  "_org_CIL-CO": {
    "EN": "<p>Center for Independent Living</p>",
    "ES": "<p>Centro de Vida Independiente</p>"
  },
  "_org_CIL-GA": {
    "EN": "Centers for Independent Living staff",
    "ES": ""
  },
  "_org_CMHC-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Community Mental Health Center",
    "ES": ""
  },
  "_org_CMHSP-MI": {
    "EN": "Community Mental Health/CMHSP",
    "ES": ""
  },
  "_org_CNTY-CA": {
    "EN": "<p>County - other</p>",
    "ES": "<p>Condado - otro</p>"
  },
  "_org_CNTY-MN": {
    "EN": "County",
    "ES": ""
  },
  "_org_COMMUNITY": {
    "EN": "Community-based service provider staff",
    "ES": "Empleado/a de un proveedor de servicios basados en la comunidad"
  },
  "_org_COUNTY": {
    "EN": "County case worker or staff",
    "ES": "Trabajador social o empleado/a del condado"
  },
  "_org_CRP-MI": {
    "EN": "Community Rehabilitation Provider",
    "ES": ""
  },
  "_org_CRP-KY": {
    "EN": "CRP/SE Provider",
    "ES": ""
  },
  "_org_CRP-NC": {
    "EN": "Community Rehabilitation Program staff",
    "ES": "Empleado/a de un Programa de Rehabilitación Comunitaria"
  },
  "_org_CRP-IA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Community Rehabilitation Program",
    "ES": ""
  },
  "_org_CSP-NJ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Community service provider",
    "ES": ""
  },
  "_org_CSP-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Community Service Provider",
    "ES": ""
  },
  "_org_CSP-GA": {
    "EN": "Community Service Board staff",
    "ES": ""
  },
  "_org_CWIC": {
    "EN": "Certified Work Incentives Coordinator (CWIC)",
    "ES": "Coordinador de Incentivos Laborales Comunitario (CWIC)"
  },
  "_org_DD-MO": {
    "EN": "Developmental Disabilities staff",
    "ES": ""
  },
  "_org_DDC-OH": {
    "EN": "Developmental Disabilities Council",
    "ES": ""
  },
  "_org_DDD-AZ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>DDD Provider",
    "ES": ""
  },
  "_org_DDD-AK": {
    "EN": "Division of Developmental Disability staff",
    "ES": ""
  },
  "_org_DHHS-NC": {
    "EN": "Other Department of Health and Human Services Staff [mental health, aging...]",
    "ES": "Otro empleado/a del Departamento de Salud y servicios Humanos [salud mental, envejecimiento...]"
  },
  "_org_DLL-MN": {
    "EN": "Disability Hub MN",
    "ES": ""
  },
  "_org_DMH-AK": {
    "EN": "Department of Mental Health staff",
    "ES": ""
  },
  "_org_DMHA-OH": {
    "EN": "Ohio Department of Mental Health and Addiction Services staff",
    "ES": ""
  },
  "_org_DOE": {
    "EN": "Department of Public Instruction (NCDPI) or school staff",
    "ES": "Empleado/a del Departamento de Instrucción Pública (NCDPI) or de una escuela"
  },
  "_org_DOE-AZ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>School/ADE",
    "ES": ""
  },
  "_org_DOR-CA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>DOR Counselor",
    "ES": ""
  },
  "_org_DVR-AK": {
    "EN": "Department of Vocational Rehabilitation",
    "ES": ""
  },
  "_org_DVR-IL": {
    "EN": "<p>Department of Vocational Rehabilitation staff</p>",
    "ES": "<p>Trabajador/a en el Departamento de Rehabilitaci&oacute;n Vocacional</p>"
  },
  "_org_ED-NJ": {
    "EN": "<p>Educator</p>",
    "ES": "<p>Educador/a</p>"
  },
  "_org_ED-MO": {
    "EN": "Education or school staff",
    "ES": ""
  },
  "_org_ED-IA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Education Agency staff",
    "ES": ""
  },
  "_org_EDD-CA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>EDD/One-Stop Staff",
    "ES": ""
  },
  "_org_EIPD-GA": {
    "EN": "Department of Vocational Rehabilitation staff",
    "ES": ""
  },
  "_org_EIPD-NC": {
    "EN": "Division of Employment and Independence for People with Disabilities (EIPD) staff",
    "ES": "Empleado/a de la División de Empleo e Independencia para Personas con Discapacidad (EIPD)"
  },
  "_org_EMP-NJ": {
    "EN": "<p>Employer</p>",
    "ES": "<p>Empleador</p>"
  },
  "_org_EMPLOYER-IA": {
    "EN": "<p>Employer</p>",
    "ES": "<p>Empleador</p>"
  },
  "_org_EMPSP-MO": {
    "EN": "Employment Specialist",
    "ES": ""
  },
  "_org_ET-OH": {
    "EN": "Education Transition staff",
    "ES": ""
  },
  "_org_FAMILY": {
    "EN": "Family of a person with a disability",
    "ES": "Familiar de una persona con discapacidad"
  },
  "_org_FAMILY-NJ": {
    "EN": "<p>Family member</p>",
    "ES": "<p>Familiar</p>"
  },
  "_org_FAMILY-MO": {
    "EN": "Family/Caregiver of a person with a disability",
    "ES": ""
  },
  "_org_FAMILY-OH": {
    "EN": "Family Member of a Person with a disability",
    "ES": ""
  },
  "_org_FAMILY-IA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Family member/guardian of an individual with a disability",
    "ES": ""
  },
  "_org_FIN-MO": {
    "EN": "Financial Advisor",
    "ES": ""
  },
  "_org_HCPF-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Healthcare Policy and Finance",
    "ES": ""
  },
  "_org_Health-MO": {
    "EN": "Healthcare Organization staff",
    "ES": ""
  },
  "_org_Health-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Healthcare Provider",
    "ES": ""
  },
  "_org_HealthOrg-IL": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Healthcare Organization staff",
    "ES": ""
  },
  "_org_HHS-IA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Health and Human Services staff",
    "ES": ""
  },
  "_org_HigherEd-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Higher Education",
    "ES": ""
  },
  "_org_IDD-GA": {
    "EN": "I/DD Provider",
    "ES": ""
  },
  "_org_IHH-IA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Individual Home Health staff",
    "ES": ""
  },
  "_org_INDIVIDUAL": {
    "EN": "Person with a disability",
    "ES": "Persona con discapacidad"
  },
  "_org_ISC-IL": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Independent Service Coordination agency staff",
    "ES": ""
  },
  "_org_JFS-OH": {
    "EN": "Ohio Department of Job and Family Services staff",
    "ES": ""
  },
  "_org_MANAGED-IA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Managed Care Organization staff",
    "ES": ""
  },
  "_org_MD-NJ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Practitioner/clinician",
    "ES": ""
  },
  "_org_MDE-MN": {
    "EN": "School",
    "ES": ""
  },
  "_org_Medi-Cal-CA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>County Medi-Cal Services Staff",
    "ES": ""
  },
  "_org_MH-MO": {
    "EN": "Mental Health staff",
    "ES": ""
  },
  "_org_MRS-MI": {
    "EN": "Michigan Rehabilitation Services",
    "ES": ""
  },
  "_org_NJ-NJ": {
    "EN": "<p>New Jersey State Department staff</p>",
    "ES": "<p>Trabajador/a estatal de New Jersey</p>"
  },
  "_org_OneStop-AZ": {
    "EN": "<p>ARIZONA@WORK</p>",
    "ES": ""
  },
  "_org_OOD-VR-OH": {
    "EN": "OOD staff - VR Counselor/Benefits Specialist",
    "ES": ""
  },
  "_org_OTHER": {
    "EN": "<p>Other</p>",
    "ES": "<p>Otro</p>"
  },
  "_org_OVR-KY": {
    "EN": "OVR",
    "ES": ""
  },
  "_org_PARTNER-NJ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Federal and non-federal partner",
    "ES": ""
  },
  "_org_PASA-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Program Approved Service Agency",
    "ES": ""
  },
  "_org_PEER-GA": {
    "EN": "Certified Peer Specialist",
    "ES": ""
  },
  "_org_POLICY-NJ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Policy expert",
    "ES": ""
  },
  "_org_PRO": {
    "EN": "<p>Other provider</p>",
    "ES": "<p>Otro proveedor</p>"
  },
  "_org_PROMISE-CA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>CaPROMISE Career Services Coordinator",
    "ES": ""
  },
  "_org_PUB-MO": {
    "EN": "Public Administrator",
    "ES": ""
  },
  "_org_RES-NJ": {
    "EN": "<p>Researcher</p>",
    "ES": "<p>Investigador/a</p>"
  },
  "_org_RSA-AZ": {
    "EN": "<p>RSA/VR</p>",
    "ES": ""
  },
  "_org_SCH-CA": {
    "EN": "<p>School</p>",
    "ES": "<p>Escuela</p>"
  },
  "_org_School-MI": {
    "EN": "Youth/School Transition Program",
    "ES": ""
  },
  "_org_School-KY": {
    "EN": "School/Education Personnel",
    "ES": ""
  },
  "_org_School-CO": {
    "EN": "<p>School District</p>",
    "ES": "<p>Distrito escolar</p>"
  },
  "_org_SEP-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Single Entry Point",
    "ES": ""
  },
  "_org_ServiceSupports-OH": {
    "EN": "Service and Supports Administrator",
    "ES": ""
  },
  "_org_STATE-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>State Agency Staff",
    "ES": ""
  },
  "_org_STATE-IL": {
    "EN": "<p>State case worker or staff</p>",
    "ES": "<p>Trabajador/a del estado</p>"
  },
  "_org_SUPPORT-MO": {
    "EN": "Support staff",
    "ES": ""
  },
  "_org_SUPPORT-GA": {
    "EN": "Support Coordinators",
    "ES": ""
  },
  "_org_TRUST-MO": {
    "EN": "Trust attorney",
    "ES": ""
  },
  "_org_User-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Parent/Youth/Person with a Disability",
    "ES": ""
  },
  "_org_VA-AZ": {
    "EN": "<p>VA</p>",
    "ES": ""
  },
  "_org_VR-MO": {
    "EN": "Vocational Rehab Counselor",
    "ES": ""
  },
  "_org_VR-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Division of Vocational Rehabilitation",
    "ES": ""
  },
  "_org_VR-IA": {
    "EN": "<p>Vocational Rehabilitation staff</p>",
    "ES": "<p>Trabajador/a de la Rehabilitaci&oacute;n Vocacional</p>"
  },
  "_org_VRS-MN": {
    "EN": "Vocational Rehabilitation Services",
    "ES": ""
  },
  "_org_WF-CO": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Workforce Center",
    "ES": ""
  },
  "_org_WIPA-CA": {
    "EN": "<p>WIPA - CWIC</p>",
    "ES": ""
  },
  "_org_WIPA-KY": {
    "EN": "WIPA",
    "ES": ""
  },
  "_org_WORKFORCE-NJ": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Local workforce board/municipal staff",
    "ES": ""
  },
  "_org_WORKFORCE-IA": {
    "EN": "<span class=\"styleTranslate\">translate all</span>Workforce Development staff",
    "ES": ""
  }
}} (jQuery));
